// src/components/Credit.tsx
//
// Canonical Analytica DSS byline component. Three tiers per PLAYBOOK §3.2.
//
// Do not modify this file in individual app repos — change the canonical
// version in analytica-meta/templates/Credit.tsx and re-copy to all apps.

type CreditTier = 1 | 2 | 3;

interface CreditProps {
  /** 1=compact, 2=standard, 3=authoritative. See PLAYBOOK §3.2 for which to use where. */
  tier?: CreditTier;
  /** Extra Tailwind classes to apply to the outer element. */
  className?: string;
}

export function Credit({ tier = 2, className = "" }: CreditProps) {
  if (tier === 1) {
    return <span className={className}>Analytica DSS</span>;
  }

  if (tier === 2) {
    return (
      <span className={className}>
        Built by Analytica Data Science Solutions
      </span>
    );
  }

  // tier === 3
  return (
    <div className={className}>
      <div>Built by Analytica Data Science Solutions</div>
    </div>
  );
}
